import React from "react";
import PropTypes from "prop-types";
import { Button, Card } from "react-bootstrap";

const FilterHeader = ({
                        title,
                        totalCount,
                        isOpen,
                        onToggle,
                        noExpand = false
                      }) => (
  <Card.Header>
    <div className="d-flex justify-content-between align-items-center">
      <h4 className="m-0">
        {title}
      </h4>
      <div>
        {totalCount ? <span className="text-success mr-3" title="Total Count">{totalCount}</span> : null}
        {noExpand || (
          <Button
            className="btn-sm"
            onClick={() => onToggle(!isOpen)}
            aria-expanded={isOpen}
          >
            Expand Search
          </Button>
        )}
      </div>
    </div>
  </Card.Header>
);

FilterHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  totalCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired
};

export default FilterHeader;



// WEBPACK FOOTER //
// ./src/views/lib/components/filter/filter-header.js